import { Component, Input, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnerInfo } from '../../order-v2.types';
import { ClipboardService } from '../../../../../core/services/clipboard/clipboard.service';

interface PartnerField {
  label: string;
  value: string | null | undefined;
}

@Component({
  selector: 'app-partner-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800/40">
      <div class="overflow-hidden">
        <div class="mb-2.5 text-lg font-semibold text-neutral-900 dark:text-white">parceiro</div>
        @for (field of fields(); track field.label) {
          <div class="flex items-start gap-1.5 py-0.5 text-sm text-neutral-900 dark:text-neutral-100">
            <button
              type="button"
              (click)="copyValue(field.value)"
              [title]="'Copiar ' + field.label"
              class="flex min-w-[80px] shrink-0 cursor-pointer items-center bg-transparent p-0 text-left text-xs text-neutral-500 focus-visible:outline-none dark:text-neutral-400"
            >
              <span class="truncate">{{ field.label }}</span>
            </button>
            <span class="min-w-0 flex-1 break-words">{{ field.value }}</span>
          </div>
        }
      </div>
    </div>
  `,
})
export class PartnerCardComponent {
  @Input({ required: true }) partner!: PartnerInfo;

  private readonly _clipboard = inject(ClipboardService);

  readonly fields = computed<PartnerField[]>(() => {
    const p = this.partner;
    if (!p) return [];
    const items: PartnerField[] = [
      { label: 'id', value: p.id },
      { label: 'nome', value: p.name },
    ];
    return items.filter((f) => f.value !== null && f.value !== undefined && String(f.value).trim().length > 0);
  });

  copyValue(value: string | null | undefined): void {
    if (value === null || value === undefined) return;
    this._clipboard.copy(String(value));
  }
}
